let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jTO9r")).then(() => parcelRequire('h7dNX'));